<script lang="ts">
    
    import type { GameType } from "../../global";
    import type { Game } from "../../Model/Game";
    import { SubscriptionsManager } from "../../Model/SubscriptionsManager";

    export let game: Game;

    const numbersByGameType: Record<GameType, number> = {
      'Bingo90': 90,
      'Bingo75': 75,
      'BingoMex': 54,
      'BingoAnimals': 54,
      'BingoCartoon': 54,
      'Movies': 54,
      'MoviesKids': 54,
      'XMas': 54,
      'Football': 54,
      'Halloween': 54,
      'Superheroes': 54,
      'Cartoon': 54
    };

    const gameSubscriptions = new SubscriptionsManager();

    let indicatorText = '';

    $: setupGame(game);

    function setupGame(game: Game): void {
        gameSubscriptions.unsubscribeAll();
        if (!game) {
            indicatorText = '';
            return;
        }
        gameSubscriptions.subscribe(game.numbers, numbers => {
            indicatorText = `${numbers.length}/${numbersByGameType[game.type]}`;
        });
    }

</script>

{indicatorText}
